module.exports = __webpack_public_path__ + "img/mitsu-Worth.6d3421a6.png";